import { render, staticRenderFns } from "./serverList.vue?vue&type=template&id=0821f140&scoped=true"
import script from "./serverList.vue?vue&type=script&lang=js"
export * from "./serverList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0821f140",
  null
  
)

export default component.exports